import { IFormValues, IMealtimeDailyValues, TMealtimeValues } from '../../types';
import { IMealtime } from '../../../../types/mealtimes.types';

const defaultSchedule: IMealtimeDailyValues = {
  start_time: '00:00',
  end_time: '23:59',
  enabled: true,
};

const getSchedules = (mealtime?: IMealtime): TMealtimeValues => {
  const schedules: TMealtimeValues = {
    MONDAY: defaultSchedule,
    TUESDAY: defaultSchedule,
    WEDNESDAY: defaultSchedule,
    THURSDAY: defaultSchedule,
    FRIDAY: defaultSchedule,
    SATURDAY: defaultSchedule,
    SUNDAY: defaultSchedule,
  };

  mealtime?.schedules.forEach((schedule) => {
    const newSchedule: IMealtimeDailyValues = {
      start_time: schedule.start_time,
      end_time: schedule.end_time,
      enabled: schedule.enabled,
    };
    schedules[schedule.day_of_week] = newSchedule;
  });
  return schedules;
};
export const createInitValues = (mealtime?: IMealtime): IFormValues => {
  const initialValue: IFormValues = {
    name: mealtime ? mealtime.name : '',
    schedules: getSchedules(mealtime),
  };

  return initialValue;
};
